// =====================================================================
// PatientAmountRow (S103) — uma linha "paciente do prontuário + valor" do
// "Registrar recebimento". Cada linha tem a PRÓPRIA busca (Autocomplete, debounce
// 400ms), pra permitir escolher vários pacientes (casal/família → recebimento
// dividido: 1 pagamento por paciente). Usado 1× (caso comum) ou N× (dividido).
// Padrão MUI v4.
// =====================================================================
import React, { useState, useRef } from "react";
import { TextField, Box, Button, CircularProgress } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { listPatients } from "../../services/patientService";

const PatientAmountRow = ({ value, onChange, onRemove, index = 0, showRemove = false }) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const debounceRef = useRef(null);

  const handleInput = (term) => {
    if (debounceRef.current) clearTimeout(debounceRef.current);
    if (!term || term.trim().length < 2) {
      setOptions([]);
      return;
    }
    debounceRef.current = setTimeout(async () => {
      setLoading(true);
      try {
        const data = await listPatients({ search: term, pageSize: 10 });
        setOptions(Array.isArray(data && data.patients) ? data.patients : []);
      } catch (e) {
        setOptions([]);
      } finally {
        setLoading(false);
      }
    }, 400);
  };

  return (
    <Box display="flex" alignItems="flex-start" style={{ gap: 8 }}>
      <Autocomplete
        style={{ flexGrow: 1, minWidth: 180 }}
        options={options}
        value={value.patient}
        loading={loading}
        getOptionLabel={(o) => (o && o.fullName) || ""}
        getOptionSelected={(o, v) => o.id === (v && v.id)}
        onChange={(e, v) => onChange({ ...value, patient: v })}
        onInputChange={(e, v) => handleInput(v)}
        noOptionsText="Digite ao menos 2 letras…"
        renderInput={(params) => (
          <TextField
            {...params}
            label={index === 0 ? "Paciente" : `Paciente ${index + 1}`}
            margin="dense"
            variant="outlined"
            placeholder="Nome / CPF / telefone"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading ? <CircularProgress size={18} /> : null}
                  {params.InputProps.endAdornment}
                </>
              )
            }}
          />
        )}
      />
      <TextField
        label="Valor"
        value={value.amount}
        onChange={(e) => onChange({ ...value, amount: e.target.value })}
        margin="dense"
        variant="outlined"
        type="number"
        inputProps={{ step: "0.01", min: "0" }}
        style={{ width: 120 }}
      />
      {showRemove && (
        <Button
          size="small"
          onClick={onRemove}
          style={{ color: "#c62828", minWidth: 0, marginTop: 12, textTransform: "none" }}
        >
          remover
        </Button>
      )}
    </Box>
  );
};

export default PatientAmountRow;
